import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'

// --- ARQUITETURA DE ESTILO COMPLETA ---
import './index.css'      // 1. A base do Tailwind
import './styles/custom.css' // 2. Os estilos do nosso "Mestre do Design"

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
